import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-single-search-alert',
  templateUrl: './single-search-alert.component.html',
  styleUrl: './single-search-alert.component.css'
})
export class SingleSearchAlertComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  interests = [];
  opening;
  company = JSON.parse(localStorage.getItem('company_' + this.businessID));
  contacted_by = [];
  routeId = this.route.snapshot.params.id;
  list;
  employer_lists = [];
  already_in_list = [];
  isValid = true;
  rights = [
    {
      highlighted: "Kaikilla",
      normal: " organisaatiossasi on oikeus nähdä profiili",
      icon_src: "../../assets/icons/people.svg",
      selected: false,
      id: 'all_in_organization',
      can_be_seen_by_others_in_same_business: true,
    },
    {
      highlighted: "Vain",
      normal: " sinulla on oikeus",
      icon_src: "../../assets/icons/lock_icon.svg",
      selected: false,
      id: 'only_me',
      can_be_seen_by_others_in_same_business: false,
    }
  ]
  storable_profile;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

    ngOnInit(): void {
      this.fetchSingleSearchAlert();
    }

    fetchSingleSearchAlert() {
      this.http.get(environment.SEARCH_ALERT + '/'+ this.routeId, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            console.log('company interests', res.message)
            var temp_list = res.message;
            var display_skills = "";
            var display_job_titles = "";
            var display_areas = "";

            for (let i = 0; i < temp_list.skills.length; i++) {
              const skill = temp_list.skills[i];
              display_skills += skill.name_fi + ", ";
              if(i == temp_list.skills.length - 1){
                display_skills = display_skills.slice(0, -2);
              }
            }

            for (let i = 0; i < temp_list.jobTitles.length; i++) {
              const job_title = temp_list.jobTitles[i];
              display_job_titles += job_title.name_fi + ", ";
              if(i == temp_list.jobTitles.length - 1){
                display_job_titles = display_job_titles.slice(0, -2);
              }
            }

            for (let i = 0; i < temp_list.areas.length; i++) {
              const location = temp_list.areas[i];
              display_areas += location.name_fi + ", ";
              if(i == temp_list.areas.length - 1){
                display_areas = display_areas.slice(0, -2);
              }
            }

            temp_list.display_skills = display_skills;
            temp_list.display_job_titles = display_job_titles;
            temp_list.display_areas = display_areas;

            this.list = temp_list;
            console.log(this.list, 'oma lista')
          }
          else {
            console.log("Error while finding status :: ", res);
            this.list = {};
          }
  
        }, (err: any) => {
  
          console.log("Error while finding status :: ", err);
        })
    }

    goBack(){
      window.history.back();
    }

    routeProfile(data) {
      console.log(data);
      this.fetchWishlist(data);
    }

    fetchContacted(type, id, userID) {

      var req = {
        businessID: this.businessID,
        id: id,
        type: type,
        userID: userID,
      }
      this.contacted_by = [];
  
      this.http.post(environment.MESSAGES_CONTACTED_BY, req, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.contacted_by = res.message;
          }
          else {
            this.opening;
          }
  
        }, (err: any) => {
  
        }
      )
    }

    saveToList() {
      var storable_profile = this.storable_profile;
  
      //find selected lists
      var selected_lists = this.employer_lists.filter(x => x.selected == true);
      console.log(selected_lists, storable_profile, 3);
  
      if (selected_lists.length == 0) {
        alert('Valitse lista');
        return;
      }
  
      //Check if profile is already in selected list
      var is_in_list = false;
      for (let i = 0; i < selected_lists.length; i++) {
        const list = selected_lists[i];
        if (list.profiles.some(profile => profile._id === storable_profile._id)) {
          is_in_list = true;
        }
      }
  
      if (is_in_list) {
        alert('Profiili on jo valitsemissasi listoissa');
        return;
      }
  
      var selected_lists_ids = selected_lists.map(x => x._id);
  
      var req = {
        lists: selected_lists_ids,
        userID: storable_profile._id
      }
  
      this.http.post(environment.SAVE_PROFILE_TO_LIST, req, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            console.log(res);
            document.getElementById('close-save-list').click();
          }
          else {
            console.log('buu')
          }
  
        }, (err: any) => {
          console.log(err)
        })
    }
  
    selectList(list) {
  
      for (let i = 0; i < this.employer_lists.length; i++) {
        var elm = this.employer_lists[i];
  
        if (elm._id == list._id) {
          elm.selected = !elm.selected;
        }
  
      }
  
    }
  
    createANewList() {
      var selected_right = this.rights.filter(x => x.selected == true);
      var title = (<HTMLInputElement>document.getElementById('list-title')).value;
      var description = (<HTMLInputElement>document.getElementById('list-description')).value;
  
      var req = {
        title: title,
        description: description,
        right: selected_right[0].id,
        profiles: [this.storable_profile._id],
        can_be_seen_by_others_in_same_business: selected_right[0].can_be_seen_by_others_in_same_business,
      }
  
      //Save list 
  
      this.http.post(environment.EMPLOYER_LISTS, req, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            console.log(res);
            document.getElementById('close_create_new_list').click();
            setTimeout(() => {
              document.getElementById('list-created').click();
            }, 100);
          }
          else {
            console.log('buu')
          }
  
        }, (err: any) => {
  
        }
      )
    }

    fetchWishlist(data) {
      var req = {
        businessID: this.businessID,
        wishListID: data._id
      }
  
      this.http.post(environment.VALIDATE_WISHLIST_OPEN + '/' + data.userID, req, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            var opening = res.message
            this.fetchContacted('wishlist', req.wishListID, data.userID)
  
  
            var languages_obj_array = opening.languages;
            var display_lang_str = "";
            var display_school_str = "";
  
            if(languages_obj_array.length > 0){
              for (let i = 0; i < languages_obj_array.length; i++) {
                var lang = languages_obj_array[i];
                display_lang_str += lang.name_fi + ', ';
              }
  
              display_lang_str = display_lang_str.slice(0, -2);
            }
            
            if(opening.profile?.schools?.length > 0){
            for (let i = 0; i < opening.profile.schools.length; i++) {
              var school = opening.profile.schools[i];
              display_school_str += school.school_name + ', ';
            }
            display_school_str = display_school_str.slice(0, -2);
            }
  
            opening.display_lang = display_lang_str;
            opening.display_school = display_school_str;
  
            this.opening = opening;
  
            //this.selectBG(opening.mdTypeID,opening);
            this.opening = opening;
            document.getElementById('oc-profile').click();
  
            this.isValid = true;
          }
          else {
            console.log('buu')
            this.opening;
          }
  
        }, (err: any) => {
  
        }
      )
    }
  
    selectRight(right) {
      for (let i = 0; i < this.rights.length; i++) {
        const elm = this.rights[i];
        elm.selected = false;
      }
  
      for (let i = 0; i < this.rights.length; i++) {
        var elm = this.rights[i];
        if (elm == right) {
          elm.selected = true;
        }
      }
  
      console.log(this.rights)
  
    }
  
    addSingleProfileToList(data) {
      var profileID = data._id;
      var req = {
        profileID: profileID,
        listID: data._id
      }
    }
  
    removeItemFromList(item) {
      console.log(item, this.storable_profile);
      var req = {
        profileID: this.storable_profile._id,
        lists: [item.id]
      }
  
      this.http.post(environment.REMOVE_PROFILE_FROM_LIST, req, this.httpOptions).subscribe(
        (res: any) => {
          if (res.status == 200) {
            console.log(res);
            //Remove all lists from already_in_list
            for (let i = 0; i < this.already_in_list.length; i++) {
              var person = this.already_in_list[i];
  
              if (person.id == item.id) {
                this.already_in_list.splice(i, 1);
              }
  
            }
          }
          else {
            console.log('buu')
          }
  
        }, (err: any) => {
  
        }
      )
  
    }
  
    routeToLists(){
      //Close modal
      document.getElementById('close-list-created').click();
      //Route to lists
      this.router.navigate(['/' + this.businessID + '/lists']);
    }

    

}
